import { getEnvironmentFromHost } from './utils/getEnvironmentFromHost';

window.environmentFromHost = getEnvironmentFromHost(window.location.host);

void import('./bootstrap');
